import React from 'react';
import { Link } from 'react-router-dom';
export function DoSomeMartialArtsRelatedLinks() {
  return <section className="py-12 bg-subtle-gray/30 border-t border-subtle-gray" data-id="element-971">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-972">
        <p className="text-sm font-bold text-gray-warm uppercase tracking-wide mb-6" data-id="element-973">
          Explore More Classes & Programs
        </p>
        <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-974">
          <Link to="/Programs.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-975">
            Programs Overview
          </Link>
          <Link to="/karate-kids-classes.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-976">
            Kids Classes
          </Link>
          <Link to="/karate-adult-classes" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-977">
            Adult Classes
          </Link>
          <Link to="/FamilyKarateClasses.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-978">
            Family Classes
          </Link>
          <Link to="/are-martial-arts-for-fitness" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-979">
            Fitness
          </Link>
          <Link to="/SignMeUp" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-980">
            Start Trial
          </Link>
        </div>
      </div>
    </section>;
}